import { ERROR } from '@/helpers/constants';
import documentationServices from '@/services/documentationServices';
import useToastContext from './useToastContext';

const useDownloadFile = () => {
  const { addToast } = useToastContext();

  const handleDocument = (attachmentId: string, res: Blob) => {
    const url = window.URL.createObjectURL(res);
    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    link.setAttribute('download', attachmentId);
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const downloadFile = (attachmentId: string, fileName: string = attachmentId?.toString()?.split('/')?.pop() ?? '') => (
    documentationServices.getDownload(attachmentId)
      .then((res) => handleDocument(fileName, res.blob))
      .catch((error) => addToast(error.message, ERROR))
  );

  const downloadPDFSubCR = (subCampaignId: string, language: string) => (
    documentationServices.pdfSubCR(subCampaignId, language)
      .then((res) => handleDocument(res.fileName || `${subCampaignId}_${language}.pdf`, res.blob))
      .catch((error) => addToast(error.message, ERROR))
  );

  const downloadPDFCR = (campaignId: string, language: string) => (
    documentationServices.pdf(campaignId, language)
      .then((res) => handleDocument(res.fileName || `${campaignId}_${language}.pdf`, res.blob))
      .catch((error) => addToast(error.message, ERROR))
  );

  return {
    downloadFile,
    downloadPDFSubCR,
    downloadPDFCR,
    handleDocument,
  };
};

export default useDownloadFile;
